import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';


export interface ChatSuggestion {
  key: string;
}

export const CHAT_SUGGESTIONS_MODE_CONFIG = {
    normal: {
        titleKey: "welcome.ideasTitle",
        icon: LightbulbOutlinedIcon,
        suggestions: [
            { key: 'crossSell' },
            { key: 'inactiveCohort' },
        ] as ChatSuggestion[]
    },
    interactive: {
        titleKey: "welcome.interactiveTitle",
        icon: AutoFixHighIcon,
        suggestions: [
            { key: 'onboardingJourney' },
            { key: 'multiVariantCampaign' },
        ] as ChatSuggestion[]
    }
};

export const DEFAULT_PLACEHOLDERS = {
  INITIAL: 'How can I help you today?',
  FOLLOWUP: 'What else can I help you with?',
} as const;
